// modal to be dynamically inserted onto page and receive content from onlick event of a dynamic-modal-trigger element
import { scroll } from "./scroll";

// for this to work, just make sure to add a dynamic-modal-trigger class to something in your html,
// or add dynamic-modal-trigger-group to the parent gorup of child groups in the gutenberg editor

export const dynamicModal = () => {
	if (!document.querySelector(".dynamic-modal-trigger") && !document.querySelector(".dynamic-modal-trigger-group"))
		return;

	insertModal();
	addTriggerEvent();
	addCloseEvent();
};

const addTriggerEvent = () => {
	let modalTriggers;

	if (document.querySelector(".dynamic-modal-trigger-group")) {
		// i'm trying to be generous with the things allowed here, hopefully this captures enough use case without breaking everything
		modalTriggers = document.querySelectorAll(
			".dynamic-modal-trigger-group .wp-block-column, .dynamic-modal-trigger-group .wp-block-group"
		);
	} else {
		modalTriggers = document.querySelectorAll(".dynamic-modal-trigger");
	}

	// count all the modal triggers.
	modalTriggers.forEach((trigger) => {
		trigger.addEventListener("click", (e) => {
			e.preventDefault();
			const modal = document.querySelector(".dynamic-modal");
			openModal(trigger, modal);
		});
	});
};

const insertModal = () => {
	/* Dynamically creating this
<div class="modal dynamic-modal">
	<div class="modal-box">
		<header class="modal-header">
			<div class="top-left-corner">
				<!-- modal img element inserted here -->
				<!-- title h3 element inserted here -->
				<!-- subtitle p.subtitle element inserted here -->
			</div>
			<div class="top-right-corner">
				<button class="close-modal" data-simple-modal-close>&times;</button>
			</div>
		</header>
		<div class="modal-body">
			<!-- content inserted here -->
		</div>
	</div>
</div>
*/
	const modal = document.createElement("div");
	modal.classList.add("modal", "dynamic-modal");

	const modalBox = document.createElement("div");
	modalBox.classList.add("modal-box");
	modal.appendChild(modalBox);

	const modalHeader = document.createElement("header");
	modalHeader.classList.add("modal-header");
	modalBox.appendChild(modalHeader);

	const topLeftCorner = document.createElement("div");
	topLeftCorner.classList.add("top-left-corner");
	modalHeader.appendChild(topLeftCorner);

	const topRightCorner = document.createElement("div");
	topRightCorner.classList.add("top-right-corner");
	modalHeader.appendChild(topRightCorner);

	const closeButton = document.createElement("button");
	closeButton.classList.add("close-modal");
	closeButton.setAttribute("data-dynamic-modal-close", "");

	const closeIcon = document.createTextNode("×");
	closeButton.appendChild(closeIcon);
	topRightCorner.appendChild(closeButton);

	const modalBody = document.createElement("div");
	modalBody.classList.add("modal-body");
	modalBox.appendChild(modalBody);

	document.body.appendChild(modal);
};

const openModal = (trigger, modal) => {
	const triggerImg = trigger.querySelector("img");
	const triggerTitle = trigger.querySelector("h3");
	const triggerSubtitle = trigger.querySelector(".subtitle");

	const modalHeader = modal.querySelector(".modal-header");
	// clone triggerImg, triggerTitle, and triggerSubtitle elements into modalHeader
	if (triggerImg) {
		const modalImg = triggerImg.cloneNode(true);
		modalHeader.querySelector(".top-left-corner").appendChild(modalImg);
	}
	if (triggerTitle) {
		const modalTitle = triggerTitle.cloneNode(true);
		modalHeader.querySelector(".top-left-corner").appendChild(modalTitle);
	}
	if (!triggerTitle || !triggerImg) return;

	if (triggerSubtitle) {
		const modalSubtitle = triggerSubtitle.cloneNode(true);
		modalHeader.querySelector(".top-left-corner").appendChild(modalSubtitle);
	}

	// clone trigger content into modalContent, lets just assume its everything after the h3, or the .subtitle element within the trigger group

	const triggerContent = intelligentlyFindContent(trigger);
	if (triggerContent) {
		const modalContent = modal.querySelector(".modal-body");
		modalContent.innerHTML = triggerContent;
		// modalContent.appendChild(triggerContent);
	}

	// add a fade in class to the modal for 0.5s and then add the open class and remove the fade in class
	modal.classList.add("fade-in");
	setTimeout(() => {
		modal.classList.remove("fade-in");
		modal.classList.add("open");
		document.body.classList.add("modal-open");
		calculateModalCenterScreenPosition(modal);
	}, 500);

	scroll.stop();

	// add event listener to close the modal
	modal.addEventListener("click", (e) => {
		if (e.target.classList.contains("modal") || e.target.classList.contains("close-modal")) {
			closeModal(modal);
		}
	});
};

const intelligentlyFindContent = (trigger) => {
	let content;
	const triggerTitle = trigger.querySelector("h3");
	const triggerSubtitle = trigger.querySelector(".subtitle");

	let nextSiblings;
	if (triggerSubtitle) {
		nextSiblings = captureAllNextSiblings(triggerSubtitle);
	} else {
		nextSiblings = captureAllNextSiblings(triggerTitle);
	}

	if (nextSiblings) {
		let siblingHtmlString = "";
		nextSiblings.forEach((sibling) => {
			siblingHtmlString += sibling.outerHTML;
		});
		content = siblingHtmlString;
	}

	return content;
};
const captureAllNextSiblings = (startElement) => {
	const siblings = [];
	let nextSibling = startElement.nextElementSibling;

	while (nextSibling) {
		siblings.push(nextSibling.cloneNode(true));
		nextSibling = nextSibling.nextElementSibling;
	}

	return siblings;
};

const closeModal = (modal) => {
	modal.classList.remove("open");
	document.body.classList.remove("modal-open");

	// destroy all the cloned elements in the header
	const modalHeader = modal.querySelector(".modal-header");
	modalHeader.querySelector(".top-left-corner").innerHTML = "";

	// destroy all the cloned elements in the content
	const modalBody = modal.querySelector(".modal-body");
	modalBody.innerHTML = "";

	modal.style.transform = ""; // Reset to whatever your default styling is
	scroll.start();
};

const addCloseEvent = () => {
	document.addEventListener("click", (e) => {
		// if we click outside the modal close it
		// if (!e.target.closest(".modal")) {
		// 	closeModal(e.target);
		// }

		// if the target has a data-dynamic-modal-close attribute, close the modal
		if (e.target.hasAttribute("data-dynamic-modal-close")) {
			const modal = e.target.closest(".dynamic-modal");
			closeModal(modal);
		}
	});
};

const calculateModalCenterScreenPosition = (modal) => {
	const modalBox = modal.querySelector(".modal-box");

	// The translateY value should bring the modal to the middle of the viewport.
	// Since the modal is already centered via CSS with translate(-50%, -50%),
	// we only need to consider the vertical alignment relative to the scroll position.
	const viewportHeight = window.innerHeight;
	const scrollY = scroll.scroll.instance.scroll.y;

	// Adjust the modal's transform to account for the current scroll position
	// We don't need to adjust by the modal's height since CSS handles vertical centering
	const translateYValue = viewportHeight / 2 + scrollY;

	modal.style.transform = `translate(-50%, -50%) translateY(${translateYValue}px)`;
};
